module.exports = __webpack_public_path__ + "media/club/canofea_serial-5139f123.webp";